<template>
    <div class="app">
      <b-navbar
        toggleable="lg"
        class="custom-navbar  align-items-start m-0 p-0 py-2"
        style="background: var(--Primary-2, #000);"
      >
         <b-navbar-brand href="/#/landing" class="pl-3 sep pr-4 mt-2">
          <svg width="149" height="40" viewBox="0 0 119 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_350_1301)">
            <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="black"/>
            <path d="M26.7244 5.27686H5.27734V26.7239H26.7244V5.27686Z" fill="#EFB914"/>
            <path d="M16.0005 24.7662C20.8418 24.7662 24.7665 20.8415 24.7665 16.0001C24.7665 11.1587 20.8418 7.23401 16.0005 7.23401C11.1591 7.23401 7.23438 11.1587 7.23438 16.0001C7.23438 20.8415 11.1591 24.7662 16.0005 24.7662Z" fill="black"/>
            <path d="M18.9433 17.3057C18.8428 17.5515 18.5369 18.2075 17.8073 18.683C17.6588 18.7796 17.0227 19.1758 16.1171 19.1662C15.9737 19.1649 14.8211 19.1348 13.9526 18.2535C13.8572 18.1569 13.6038 17.8875 13.3971 17.4663C13.1833 17.0299 13.0758 16.5409 13.0758 15.9995C13.0758 15.403 13.2102 14.8635 13.4784 14.3803C13.6896 14.0001 13.9276 13.7614 13.9936 13.6961C14.8384 12.866 15.943 12.8353 16.1171 12.8327C16.2848 12.8308 17.0656 12.834 17.8163 13.307C18.1324 13.506 18.343 13.7255 18.4102 13.7979C18.6265 14.0308 18.8038 14.2996 18.9433 14.6036H20.9113C20.6489 13.4945 20.0825 12.6062 19.2121 11.938C18.7552 11.5873 18.2547 11.3294 17.712 11.163V9.79785H16.3219V10.9396C16.2598 10.9377 16.1977 10.9364 16.135 10.9364C15.9808 10.9364 15.8291 10.9428 15.68 10.9543V9.79785H14.2899V11.2455C13.6294 11.4855 13.0361 11.8644 12.5126 12.3854C11.5404 13.3511 11.0547 14.5531 11.0547 15.9899C11.0547 17.4267 11.5404 18.6311 12.5126 19.6033C13.038 20.1287 13.6307 20.5108 14.2899 20.7521V22.1998H15.68V21.0439C15.8233 21.0542 15.9686 21.0606 16.1171 21.0606C16.1856 21.0606 16.254 21.0593 16.3212 21.0567V22.1991H17.7113V20.827C18.2579 20.6561 18.7609 20.3918 19.2204 20.0321C20.0972 19.3467 20.672 18.4372 20.9465 17.3044H18.9433V17.3057Z" fill="#EFB914"/>
            </g>
            <path d="M101.188 26.4426C100.998 26.4426 100.808 26.4426 100.619 26.4426C100.562 26.4426 100.543 26.4603 100.545 26.5174C100.55 26.6192 100.556 26.72 100.559 26.8218C100.561 26.8935 100.559 26.9642 100.559 27.0442C100.451 26.8738 100.325 26.7315 100.164 26.6244C99.7891 26.374 99.3755 26.3304 98.9464 26.4198C98.4311 26.5268 98.082 26.8489 97.8565 27.3133C97.6945 27.6468 97.628 28.0032 97.6217 28.372C97.6155 28.7055 97.6539 29.0328 97.7713 29.3466C97.9106 29.7206 98.136 30.025 98.4903 30.2224C98.775 30.3804 99.0846 30.4365 99.4078 30.423C99.8867 30.4043 100.264 30.2006 100.535 29.8027C100.55 29.7819 100.563 29.7611 100.583 29.732C100.585 29.7549 100.587 29.7674 100.587 29.7788C100.587 29.9097 100.588 30.0406 100.587 30.1715C100.585 30.3534 100.569 30.5341 100.517 30.7097C100.411 31.0692 100.192 31.3196 99.8202 31.4162C99.5927 31.4755 99.362 31.4734 99.1345 31.4204C99.0368 31.3975 98.9381 31.3643 98.8498 31.3186C98.6171 31.1991 98.4903 30.9996 98.4477 30.744C98.4373 30.6848 98.4186 30.664 98.3667 30.663C98.1776 30.663 97.9875 30.663 97.7984 30.663C97.7485 30.663 97.7298 30.6848 97.7339 30.7357C97.7506 30.9414 97.8077 31.1347 97.9168 31.3103C98.0955 31.5981 98.3615 31.7705 98.6784 31.8682C99.1033 31.9991 99.5376 32.0095 99.9709 31.9233C100.57 31.8048 100.98 31.462 101.162 30.8687C101.237 30.6225 101.253 30.3679 101.252 30.1113C101.248 29.5097 101.249 28.9071 101.248 28.3055C101.248 28.1995 101.245 28.0936 101.246 27.9865C101.25 27.4941 101.256 27.0016 101.26 26.5091C101.26 26.4572 101.243 26.4405 101.191 26.4405L101.188 26.4426ZM100.443 29.2822C100.313 29.5949 100.097 29.8183 99.7569 29.8889C99.415 29.9596 99.0867 29.9253 98.801 29.704C98.6046 29.5513 98.4966 29.3403 98.429 29.1076C98.3667 28.8915 98.3449 28.6702 98.3428 28.4468C98.3407 28.1912 98.3625 27.9398 98.4384 27.6946C98.4955 27.5086 98.5807 27.3372 98.7148 27.1938C98.8966 26.9995 99.1251 26.907 99.388 26.8904C99.6602 26.8738 99.9117 26.9299 100.126 27.1107C100.294 27.253 100.4 27.4369 100.471 27.6426C100.548 27.8671 100.58 28.0998 100.585 28.3367C100.585 28.371 100.585 28.4042 100.585 28.4385C100.585 28.7284 100.557 29.0131 100.445 29.2842L100.443 29.2822Z" fill="#F4F5F6"/>
            <path d="M94.8487 26.4697C94.8529 27.249 94.8612 27.8786 94.8861 28.4126C94.8924 28.5394 94.9017 28.8885 94.7448 29.2688C94.6129 29.5857 94.3947 29.8111 94.0498 29.8828C93.7038 29.9545 93.3713 29.9202 93.0825 29.6958C92.884 29.542 92.7739 29.328 92.7053 29.0911C92.6658 28.9571 92.6409 28.8365 92.618 28.422C92.5931 27.9835 92.591 27.6479 92.591 27.5742C92.59 27.2646 92.589 26.8916 92.591 26.4666H91.9261C91.9053 27.0204 91.8897 27.65 91.8887 28.3482C91.8887 28.5997 91.8939 28.9394 92.0393 29.3353C92.1796 29.7145 92.4082 30.022 92.7677 30.2215C93.0565 30.3815 93.3692 30.4376 93.6965 30.4252C94.1807 30.4054 94.5641 30.2007 94.8373 29.7976C94.8519 29.7768 94.8654 29.7561 94.8861 29.7259C94.8882 29.7498 94.8903 29.7612 94.8903 29.7737C94.8903 29.9067 94.8913 30.0387 94.8903 30.1716C94.8882 30.3555 94.8726 30.5384 94.8197 30.7161C94.7126 31.0808 94.4903 31.3332 94.1142 31.4319C93.8835 31.4922 93.6508 31.4901 93.4191 31.4361C93.3204 31.4132 93.2207 31.3789 93.1303 31.3322C92.8944 31.2117 92.7666 31.0091 92.723 30.7504C92.7126 30.6901 92.6939 30.6693 92.6409 30.6683C92.4487 30.6683 92.2575 30.6683 92.0653 30.6683C92.0144 30.6683 91.9957 30.6901 91.9998 30.742C92.0165 30.9498 92.0736 31.1452 92.1848 31.3239C92.3656 31.6148 92.6357 31.7893 92.9557 31.8881C93.3859 32.021 93.8253 32.0304 94.2648 31.9442C94.8716 31.8247 95.2862 31.4766 95.4701 30.8761C95.5469 30.6267 95.5625 30.3701 95.5615 30.1093C95.5573 29.5005 95.5584 28.8906 95.5573 28.2807C95.5573 28.1602 95.5553 28.0739 95.5553 27.9586C95.5521 27.3113 95.5615 26.797 95.5698 26.4635C95.3298 26.4656 95.0898 26.4677 94.8498 26.4697H94.8487Z" fill="#F4F5F6"/>
            <path d="M110.868 26.4416C110.68 26.4416 110.492 26.4416 110.304 26.4416C110.238 26.4416 110.222 26.4583 110.224 26.5237C110.229 26.692 110.234 26.8604 110.24 27.0391C110.225 27.0193 110.218 27.0068 110.208 26.9954C110.132 26.904 110.062 26.8032 109.976 26.7222C109.715 26.478 109.396 26.3772 109.044 26.3658C108.624 26.3512 108.251 26.4718 107.938 26.7575C107.701 26.9746 107.546 27.2448 107.443 27.5461C107.335 27.8619 107.295 28.1882 107.301 28.5217C107.307 28.8272 107.35 29.1253 107.453 29.4131C107.563 29.7228 107.732 29.996 107.991 30.2038C108.283 30.4365 108.62 30.5301 108.99 30.5249C109.476 30.5176 109.869 30.3285 110.161 29.9378C110.188 29.9015 110.213 29.8641 110.245 29.8194C110.246 29.8422 110.248 29.8537 110.247 29.8651C110.243 30.0355 110.238 30.2069 110.234 30.3773C110.233 30.4324 110.251 30.449 110.305 30.449C110.494 30.449 110.684 30.449 110.873 30.449C110.927 30.449 110.946 30.4303 110.945 30.3763C110.943 30.1706 110.939 29.9638 110.937 29.7581C110.933 29.2459 110.924 28.7336 110.926 28.2204C110.929 27.6531 110.939 27.0848 110.945 26.5175C110.945 26.4583 110.929 26.4406 110.868 26.4406V26.4416ZM110.261 28.5529C110.255 28.8105 110.222 29.0651 110.128 29.3082C110.03 29.5648 109.877 29.7768 109.623 29.9004C109.272 30.0708 108.74 30.0511 108.427 29.7207C108.261 29.5461 108.167 29.3352 108.107 29.1056C108.047 28.8781 108.029 28.6453 108.026 28.4043C108.03 28.1154 108.059 27.8245 108.173 27.5482C108.301 27.2406 108.507 27.011 108.839 26.9279C109.161 26.8468 109.473 26.8697 109.752 27.0713C109.956 27.2188 110.074 27.4266 110.152 27.6604C110.249 27.9502 110.27 28.2505 110.263 28.5529H110.261Z" fill="#F4F5F6"/>
            <path d="M105.404 26.5113C105.404 26.4593 105.386 26.4417 105.334 26.4417C105.14 26.4417 104.946 26.4417 104.752 26.4417C104.702 26.4417 104.685 26.4593 104.685 26.5082C104.685 26.5809 104.69 26.6526 104.691 26.7253C104.692 26.823 104.691 26.9207 104.691 27.0277C104.678 27.009 104.67 26.9965 104.661 26.984C104.582 26.8656 104.488 26.7596 104.377 26.6703C104.123 26.4656 103.827 26.3773 103.504 26.3658C103.121 26.3523 102.773 26.451 102.472 26.6931C102.185 26.9248 102.005 27.2292 101.892 27.5752C101.772 27.9368 101.74 28.3087 101.766 28.6869C101.788 29.0184 101.859 29.3384 102.006 29.6376C102.167 29.9649 102.4 30.2236 102.735 30.3815C103.028 30.5197 103.337 30.5519 103.655 30.5114C103.993 30.4688 104.281 30.3233 104.51 30.0709C104.579 29.995 104.638 29.9119 104.706 29.8267C104.706 29.8444 104.706 29.8589 104.706 29.8735C104.701 30.0397 104.697 30.2059 104.693 30.3722C104.692 30.4293 104.708 30.4501 104.758 30.4501C104.953 30.4501 105.147 30.4501 105.34 30.4501C105.385 30.4501 105.404 30.4304 105.404 30.3846C105.404 30.3265 105.402 30.2683 105.401 30.209C105.396 29.8828 105.391 29.5566 105.388 29.2303C105.385 28.821 105.385 28.4116 105.385 28.0022C105.385 27.8703 105.386 27.7373 105.388 27.6053C105.393 27.2407 105.399 26.876 105.403 26.5113H105.404ZM104.716 28.6682C104.701 28.901 104.663 29.1295 104.573 29.3467C104.455 29.6272 104.272 29.8485 103.975 29.942C103.604 30.0594 103.25 30.0303 102.94 29.7696C102.755 29.6137 102.654 29.4028 102.586 29.1763C102.511 28.9269 102.488 28.6703 102.485 28.4085C102.488 28.1248 102.516 27.8422 102.622 27.5731C102.727 27.3061 102.889 27.0807 103.165 26.9757C103.574 26.8199 103.967 26.8438 104.307 27.1523C104.482 27.3124 104.577 27.5233 104.638 27.7498C104.72 28.0511 104.735 28.3597 104.716 28.6693V28.6682Z" fill="#F4F5F6"/>
            <path d="M118.592 26.4416C118.404 26.4416 118.216 26.4416 118.027 26.4416C117.955 26.4416 117.939 26.453 117.917 26.5205C117.64 27.3912 117.361 28.2629 117.084 29.1336C117.044 29.2603 117.003 29.3881 116.959 29.5242C116.949 29.4962 116.941 29.4785 116.934 29.4598C116.563 28.4769 116.191 27.4941 115.82 26.5101C115.801 26.4603 115.772 26.4405 115.72 26.4416C115.504 26.4426 115.289 26.4416 115.073 26.4416C115.009 26.4416 115 26.4572 115.024 26.5174C115.207 26.9777 115.389 27.4369 115.573 27.8972C115.908 28.7377 116.244 29.5793 116.577 30.4209C116.585 30.4427 116.585 30.4718 116.578 30.4947C116.442 30.8926 116.304 31.2905 116.166 31.6885C116.143 31.7539 116.156 31.7716 116.226 31.7716C116.398 31.7716 116.571 31.7716 116.743 31.7716C116.805 31.7716 116.823 31.7581 116.842 31.703C117.279 30.4531 117.717 29.2022 118.154 27.9523C118.32 27.4785 118.486 27.0037 118.652 26.5288C118.677 26.4582 118.665 26.4426 118.593 26.4426L118.592 26.4416Z" fill="#F4F5F6"/>
            <path d="M114.833 30.371C114.42 29.7112 114.006 29.0515 113.591 28.3927C113.571 28.3595 113.57 28.3366 113.591 28.3034C113.962 27.7081 114.332 27.1127 114.702 26.5163C114.713 26.4997 114.716 26.4779 114.722 26.4582C114.702 26.453 114.682 26.4426 114.663 26.4426C114.478 26.4415 114.293 26.4426 114.108 26.4415C114.05 26.4415 114.012 26.4633 113.984 26.5122C113.807 26.8124 113.628 27.1127 113.449 27.413C113.343 27.5917 113.237 27.7694 113.126 27.9553C113.113 27.9346 113.103 27.921 113.095 27.9065C112.807 27.439 112.518 26.9714 112.231 26.5028C112.208 26.4633 112.176 26.4415 112.131 26.4415C111.906 26.4415 111.681 26.4415 111.456 26.4415C111.41 26.4415 111.4 26.4613 111.424 26.5028C111.429 26.5122 111.436 26.5205 111.442 26.5298C111.823 27.1169 112.204 27.7039 112.587 28.2899C112.603 28.3148 112.605 28.3325 112.589 28.3595C112.463 28.5569 112.34 28.7554 112.215 28.9528C111.918 29.4265 111.619 29.9014 111.322 30.3762C111.312 30.3928 111.31 30.4146 111.305 30.4344C111.324 30.4396 111.344 30.4489 111.364 30.4489C111.558 30.4499 111.752 30.4489 111.946 30.4489C111.997 30.4489 112.032 30.4312 112.06 30.3866C112.289 30.0105 112.518 29.6354 112.748 29.2603C112.847 29.0993 112.945 28.9382 113.046 28.773C113.056 28.7896 113.066 28.8011 113.073 28.8135C113.392 29.3361 113.712 29.8577 114.03 30.3803C114.06 30.4302 114.099 30.4499 114.155 30.4489C114.295 30.4468 114.435 30.4489 114.575 30.4489C114.654 30.4489 114.732 30.4489 114.811 30.4489C114.855 30.4489 114.865 30.4292 114.845 30.3897C114.84 30.3834 114.836 30.3772 114.832 30.3699L114.833 30.371Z" fill="#F4F5F6"/>
            <path d="M106.782 26.2856C106.785 25.8856 106.788 25.4856 106.791 25.0856C106.791 25.017 106.778 25.0035 106.711 25.0035C106.529 25.0035 106.347 25.0035 106.165 25.0035C106.09 25.0035 106.078 25.0139 106.079 25.0877C106.082 25.3828 106.085 25.6789 106.089 25.974C106.092 26.3158 106.097 26.6576 106.097 26.9984C106.097 27.574 106.094 28.1496 106.091 28.7252C106.087 29.2727 106.082 29.8213 106.078 30.3689C106.078 30.4354 106.093 30.4489 106.16 30.4489C106.343 30.4489 106.527 30.4489 106.71 30.4489C106.773 30.4489 106.79 30.4333 106.789 30.3709C106.787 30.2047 106.785 30.0385 106.783 29.8722C106.779 29.5148 106.775 29.1584 106.773 28.801C106.772 28.4436 106.773 28.0873 106.773 27.7298C106.773 27.7298 106.771 27.7298 106.77 27.7298C106.77 27.5885 106.77 27.4472 106.77 27.3049C106.772 26.9651 106.776 26.6244 106.779 26.2846L106.782 26.2856Z" fill="#F4F5F6"/>
            <path d="M89.9684 26.5633C89.317 26.5633 88.8484 26.8469 88.5897 27.2989H88.573V24.7585H87.8457V29.6543C87.8457 30.0054 87.8291 30.4148 87.8125 30.6901H88.4473L88.4806 30.0304H88.4972C88.8058 30.5571 89.2743 30.7826 89.8593 30.7826C90.7528 30.7826 91.6806 30.0636 91.6806 28.6184C91.6806 27.3986 90.97 26.5633 89.9674 26.5633H89.9684ZM89.7097 30.1976C89.1829 30.1976 88.7486 29.8548 88.6073 29.3374C88.5824 29.2542 88.5741 29.1618 88.5741 29.0703V28.3431C88.5741 28.2256 88.599 28.1342 88.6156 28.0417C88.7663 27.4817 89.2338 27.1399 89.7274 27.1399C90.5211 27.1399 90.9388 27.8329 90.9388 28.6444C90.9388 29.5722 90.4879 30.1987 89.7107 30.1987L89.7097 30.1976Z" fill="#F4F5F6"/>
            <path d="M49.2179 8.66455C48.2392 7.72115 47.0204 7.24841 45.5596 7.24841H40V21.7163H43.1419V17.1905H45.5596C47.0204 17.1905 48.2392 16.7188 49.2179 15.7743C50.1956 14.8309 50.6849 13.6455 50.6849 12.22C50.6849 10.7945 50.1956 9.60899 49.2179 8.66559V8.66455ZM46.9342 13.7171C46.555 14.1026 46.0563 14.2959 45.436 14.2959H43.1419V10.142H45.436C46.0563 10.142 46.555 10.3384 46.9342 10.7311C47.3134 11.1238 47.5025 11.6236 47.5025 12.2293C47.5025 12.835 47.3134 13.3317 46.9342 13.7171Z" fill="#F4F5F6"/>
            <path d="M55.9144 7.24841L50.252 21.7163H53.5591L54.5513 18.9671H60.3177L61.3307 21.7163H64.7198L58.8714 7.24841H55.9155H55.9144ZM55.5414 16.2388L57.422 11.0719L59.3234 16.2388H55.5414Z" fill="#F4F5F6"/>
            <path d="M70.2586 13.0356L66.9099 7.24841H63.582L68.6253 15.846V21.7163H71.8493V15.8668L76.9341 7.24841H73.6062L70.2586 13.0356Z" fill="#F4F5F6"/>
            <path d="M77.6973 8.943H82.0995V21.7163H83.9187V8.943H88.3209V7.24841H77.6973V8.943Z" fill="#F4F5F6"/>
            <path d="M96.6397 7C94.4558 7 92.6469 7.71274 91.2141 9.13927C89.7814 10.5658 89.0645 12.3497 89.0645 14.4921C89.0645 16.6345 89.7803 18.4154 91.2141 19.8346C92.6469 21.2539 94.4558 21.9635 96.6397 21.9635C98.8237 21.9635 100.631 21.2539 102.065 19.8346C103.498 18.4154 104.215 16.6314 104.215 14.4817C104.215 12.3321 103.498 10.5481 102.065 9.12888C100.631 7.70963 98.8237 7 96.6397 7ZM100.731 18.5639C99.6497 19.6455 98.2855 20.1868 96.6387 20.1868C94.9919 20.1868 93.6277 19.6424 92.5461 18.5546C91.4645 17.4668 90.9232 16.1088 90.9232 14.4828C90.9232 12.8568 91.4635 11.4999 92.5461 10.411C93.6277 9.32318 94.9919 8.77875 96.6387 8.77875C98.2855 8.77875 99.6486 9.32006 100.731 10.4016C101.813 11.4832 102.354 12.8443 102.354 14.4838C102.354 16.1233 101.813 17.4844 100.731 18.566V18.5639Z" fill="#F4F5F6"/>
            <path d="M116.946 7.24841V18.4092L108.824 7.24841H107.191V21.7163H108.947V10.4308L117.195 21.7163H118.723V7.24841H116.946Z" fill="#F4F5F6"/>
            <defs>
            <clipPath id="clip0_350_1301">
            <rect width="32" height="32" fill="white"/>
            </clipPath>
            </defs>
          </svg>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse" class="nav-toggle"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav class="nav-collapse-modern">
        <!-- Language changer — рядом с логотипом (левая группа). -->
        <b-navbar-nav class="nav-left">
          <b-nav-item class="pt-2">
            <b-dropdown
              id="lang-dropdown"
              size="sm"
              variant="outline-light"
              toggle-class="lang-toggle"
              menu-class="dropdown-modern dropdown-high-z"
              no-caret
              boundary="viewport"
            >
              <template #button-content>
                <span class="lang-flag">{{ currentLangFlag }}</span>
              </template>

              <b-dropdown-item
                v-for="lang in languages"
                :key="lang.code"
                @click="setLanguage(lang.code)"
                class="d-flex align-items-center justify-content-between"
              >
                <div class="w-100 d-flex align-items-center">
                  <span class="mr-1">{{ lang.flag }}</span>
                  <span>{{ lang.label }}</span>
                  <b-icon
                    class="mt-1 ml-auto"
                    v-if="lang.code === currentLang"
                    icon="check2"
                    scale="0.9"
                  ></b-icon>
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </b-nav-item>
        </b-navbar-nav>

        <!-- KYC / limit panel — слева, сразу после языка. -->
        <b-navbar-nav class="nav-kyc" v-if="hasRole('CLIENT')">
          <b-nav-item class="px-3 py-2 d-none d-md-block kyc-card">
            <small class="text-uppercase text-muted d-block reg-label mb-1 text-left">
              Идентификация
            </small>
            <b-badge pill class="kyc-value">{{ onboardingStatusLabel }}</b-badge>
          </b-nav-item>

          <b-nav-item class="px-3 py-2 d-none d-md-block kyc-card">
            <small class="text-uppercase text-muted d-block reg-label mb-1 text-left">
              Классификация
            </small>
            <b-badge pill class="kyc-value">{{ classStatusLines.main }}</b-badge>
          </b-nav-item>

          <b-nav-item class="px-3 py-2 d-none d-md-block kyc-card">
            <small class="text-uppercase text-muted d-block reg-label mb-1 text-left">
              Доступный лимит на месяц
            </small>
            <b-badge
              pill
              class="kyc-value"
              :title="'Использовано ' + (Math.max(0, limitInvestment - limitRemaining)) + ' $ из ' + limitInvestment + ' $ месячного лимита'"
            >
              <span class="kyc-dollar mr-1">$</span>
              {{ limitRemaining | money(0) }} / {{ limitInvestment | money(0) }}
            </b-badge>
          </b-nav-item>

          <!-- Действия — в одном ряду, рядом с блоками. -->
          <b-nav-item class="px-2 py-2">
            <div class="kyc-actions">
              <b-button
                v-if="loadedUserData.clientCategory
                      && loadedUserData.clientCategory !== 'NONE'
                      && (loadedUserData.isSurveyShown === 1 || loadedUserData.isSurveyShown === true)"
                size="sm"
                variant="outline-light"
                class="px-3 rounded-pill d-flex align-items-center justify-content-center kyc-btn"
                @click="changeRoute('upgradeplan')"
              >
                <b-icon icon="arrow-up-circle" class="mr-2"></b-icon>
                <span class="text-nowrap">Повысить лимит</span>
              </b-button>
              <b-button
                size="sm"
                variant="success"
                class="px-3 rounded-pill d-flex align-items-center justify-content-center btn-trade kyc-btn"
                @click="changeRoute('createOrder')"
              >
                <b-icon icon="file-earmark-plus" class="mr-2"></b-icon>
                <span class="text-nowrap">Создать ордер</span>
              </b-button>
            </div>
          </b-nav-item>
        </b-navbar-nav>

        <!-- NOT CLIENT (guest) -->
        <b-navbar-nav class="ml-auto nav-right" v-if="!hasRole('CLIENT')">
          <!-- Login -->
          <b-nav-item class="pl-lg-2 pt-2">
            <b-button
              size="sm"
              variant="outline-light"
              class="px-3 rounded-pill d-flex align-items-center btn-ghost"
              @click="changeRoute('login')"
            >
              <b-icon icon="box-arrow-in-right" class="mr-2"></b-icon>
              <span class="text-nowrap">
                {{$t('ex.mainMenu.login')}}
              </span>
            </b-button>
          </b-nav-item>

          <!-- Register -->
          <b-nav-item class="pl-2 pt-2">
            <b-button
              size="sm"
              variant="warning"
              class="px-3 rounded-pill d-flex align-items-center font-weight-semibold btn-gold"
              @click="changeRoute('reg')"
            >
              <b-icon icon="person-plus-fill" class="mr-2"></b-icon>
              <span class="text-nowrap">
                {{$t('ex.mainMenu.reg')}}
              </span>
            </b-button>
          </b-nav-item>
        </b-navbar-nav>

        <!-- CLIENT LOGGED-IN -->
        <b-navbar-nav class="ml-auto nav-right" v-if="hasRole('CLIENT')">

          <!-- Notification bell — polls /api/notifications every 30s;
               dropdown shows the most recent 8, full list at /notifications. -->
          <b-nav-item class="pl-2 pr-0 mt-2">
            <NotificationBell />
          </b-nav-item>

          <!-- User dropdown -->
          <b-nav-item class="pl-0 mt-2">
           <b-dropdown
              id="dropdown-1"
              right
              no-caret
              variant="outline-light"
              menu-class="user-menu-dropdown dropdown-modern dropdown-high-z"
              toggle-class="user-toggle"
              boundary="viewport"
            >
              <template #button-content>
                <b-icon icon="person-circle"></b-icon>
              </template>

              <b-dropdown-text class="px-3 pt-1 pb-1 user-menu-header">
                <div class="d-flex align-items-center">
                  <div
                    class="rounded-circle d-inline-flex align-items-center justify-content-center mr-3"
                    style="width:36px;height:36px;background:rgba(255,255,255,0.06);"
                  >
                    <b-icon icon="person-fill" scale="1"></b-icon>
                  </div>
                  <div class="text-left">
                    <div class="font-weight-semibold text-white text-truncate" style="max-width: 220px;">
                      {{ userEmail || 'Клиент Payton.kz' }}
                    </div>
                  </div>
                </div>
              </b-dropdown-text>

              <b-dropdown-divider></b-dropdown-divider>

              <b-dropdown-item @click="changeRoute('profile')">
                <b-icon icon="person-fill" class="mr-2 text-info"></b-icon>
                Мой профиль
              </b-dropdown-item>

              <b-dropdown-item @click="guardClientNav('orders')">
                <b-icon icon="file-earmark-text" class="mr-2 text-info"></b-icon>
                Мои ордера
              </b-dropdown-item>
             

              <b-dropdown-item @click="guardClientNav('bankinfo')">
                <b-icon icon="bank2" class="mr-2 text-info"></b-icon>
                Реквизиты Payton
              </b-dropdown-item>

              <b-dropdown-item @click="guardClientNav('wallet')">
                <b-icon icon="book" class="mr-2 text-info"></b-icon>
                Мои балансы
              </b-dropdown-item>

              <b-dropdown-item @click="guardClientNav('digitalwallet')">
                <b-icon icon="wallet2" class="mr-2 text-info"></b-icon>
                Мои кошельки
              </b-dropdown-item>

              <b-dropdown-divider></b-dropdown-divider>

              <b-dropdown-item @click="logOut()" class="text-danger font-weight-semibold">
                <b-icon icon="box-arrow-right" class="mr-2"></b-icon>
                Выйти
              </b-dropdown-item>
            </b-dropdown>

          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>

      </b-navbar>

      <b-container fluid>
        <b-row class="p-0 m-0">
          <b-col class="p-0 m-0">
            <!-- Аккаунт заморожен: вход в ЛК сохранён, сервисы недоступны. -->
            <div v-if="hasRole('CLIENT') && isAccountFrozen" class="frozen-banner">
              <b-icon icon="exclamation-octagon-fill" class="mr-2"></b-icon>
              <span>
                Ваш аккаунт заморожен по результатам проверки. Доступ к личному кабинету сохранён,
                однако сервисы (пополнение и операции) временно недоступны.
                По вопросам обратитесь в поддержку: support@payton.kz
              </span>
            </div>
            <router-view></router-view>
            <b-col lg="12" class="p-0 m-0 main-sep mt-5"></b-col>

                  <!-- begining of the footer -->
        <b-col lg="12" class="p-0 m-0">
          <b-row class="p-0 m-0">
            <b-col lg="12" class="m-0 p-0">
              <b-row class="m-0 p-0">
                <b-col lg="12" class="m-0 p-0">
                  <b-row class="m-0 p-0">

                    <b-col lg="1" class="m-0 p-0 pt-5">
                      <svg width="119" height="32" viewBox="0 0 119 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_350_6798)">
                          <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="black"/>
                          <path d="M26.7244 5.27686H5.27734V26.7239H26.7244V5.27686Z" fill="#EFB914"/>
                          <path d="M16.0005 24.766C20.8418 24.766 24.7665 20.8413 24.7665 16C24.7665 11.1586 20.8418 7.23389 16.0005 7.23389C11.1591 7.23389 7.23438 11.1586 7.23438 16C7.23438 20.8413 11.1591 24.766 16.0005 24.766Z" fill="black"/>
                          <path d="M18.9433 17.3057C18.8428 17.5515 18.5369 18.2075 17.8073 18.683C17.6588 18.7796 17.0227 19.1758 16.1171 19.1662C15.9737 19.1649 14.8211 19.1348 13.9526 18.2535C13.8572 18.1569 13.6038 17.8875 13.3971 17.4663C13.1833 17.0299 13.0758 16.5409 13.0758 15.9995C13.0758 15.403 13.2102 14.8635 13.4784 14.3803C13.6896 14.0001 13.9276 13.7614 13.9936 13.6961C14.8384 12.866 15.943 12.8353 16.1171 12.8327C16.2848 12.8308 17.0656 12.834 17.8163 13.307C18.1324 13.506 18.343 13.7255 18.4102 13.7979C18.6265 14.0308 18.8038 14.2996 18.9433 14.6036H20.9113C20.6489 13.4945 20.0825 12.6062 19.2121 11.938C18.7552 11.5873 18.2547 11.3294 17.712 11.163V9.79785H16.3219V10.9396C16.2598 10.9377 16.1977 10.9364 16.135 10.9364C15.9808 10.9364 15.8291 10.9428 15.68 10.9543V9.79785H14.2899V11.2455C13.6294 11.4855 13.0361 11.8644 12.5126 12.3854C11.5404 13.3511 11.0547 14.5531 11.0547 15.9899C11.0547 17.4267 11.5404 18.6311 12.5126 19.6033C13.038 20.1287 13.6307 20.5108 14.2899 20.7521V22.1998H15.68V21.0439C15.8233 21.0542 15.9686 21.0606 16.1171 21.0606C16.1856 21.0606 16.254 21.0593 16.3212 21.0567V22.1991H17.7113V20.827C18.2579 20.6561 18.7609 20.3918 19.2204 20.0321C20.0972 19.3467 20.672 18.4372 20.9465 17.3044H18.9433V17.3057Z" fill="#EFB914"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_350_6798">
                            <rect width="32" height="32" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </b-col>

                    <b-col lg="4" class="m-0 p-0 text-left pt-5" style="border-right:1px solid var(--Neutrals-2, #23262F);">
                      <div class="d-inline-block pl-5 text-left">
                        <div class="footer-link mb-3"><a href="javascript:void(0)" @click="changeRouteTop('About')" class="no-style">О компании</a></div>
                        <div class="footer-link mb-3"><a href="javascript:void(0)" @click="changeRouteTop('DocList')" class="no-style">Лицензии и документы</a></div>
                        <div class="footer-link mb-3"><a href="javascript:void(0)" @click="changeRouteTop('Commission')" class="no-style">Комиссии Payton.kz</a></div>
                        <div class="footer-link mb-3"><a href="javascript:void(0)" @click="changeRouteTop('Terms')" class="no-style">Пользовательское соглашение</a></div>
                        <div class="footer-link mb-3"><a href="javascript:void(0)" @click="changeRouteTop('Policy')" class="no-style">Политика конфиденциальности</a></div>
                        <div class="footer-link mb-3"><a href="javascript:void(0)" @click="changeRouteTop('Risk')" class="no-style">Предупреждение о рисках</a></div>
                      </div>
                    </b-col>

                    <b-col lg="3" class="m-0 p-0 text-center pt-5" style="border-right:1px solid var(--Neutrals-2, #23262F);">
                      <div class="d-inline-block text-left">
                        <div class="footer-addr mb-3">
                          <div class="mx-auto px-4 rounded-3"
                            style="background: rgba(0,0,0,0.75); max-width: 900px; text-align: justify; line-height: 1.2;">
                            <div class="footer-section-title mb-2">Контакты</div>
                            <p class="mb-2"><strong>Email:</strong> <a href="mailto:support@payton.kz" class="link-light" style="text-decoration:none;">support@payton.kz</a></p>
                            <p class="mb-3"><strong>Адрес:</strong> Республика Казахстан, г. Астана, ул. Туркестан, дом 8/2, н.п. 11, офис 1104</p>

                            <div class="footer-section-title footer-section-title--gap mb-2">Жалобы и претензии</div>
                            <p class="mb-2">
                              По всем вопросам, связанным с использованием услуг платформы payton.kz, а также в случае
                              возникновения жалоб или претензий, вы можете связаться с нами по электронной почте:
                              <a href="mailto:support@payton.kz" class="link-light" style="text-decoration:none;">support@payton.kz</a>
                            </p>
                            <p class="mb-0">
                              Если ваш вопрос или жалоба не были урегулированы Компанией, вы также вправе обратиться в
                              Astana Financial Services Authority (AFSA) по электронной почте:
                              <a href="mailto:fintechlab@afsa.kz" class="link-light" style="text-decoration:none;">fintechlab@afsa.kz</a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </b-col>

                    <b-col lg="4" class="m-0 p-0 text-center pt-5">
                      <div class="d-inline-block pl-5 text-left">
                        <div class="footer-addr mb-3">
                          <div class="mx-auto shadow-sm"
                            style="background: rgba(0, 0, 0, 0.75); max-width: 900px; text-align: justify; line-height: 1.2;">
                            <div class="d-flex justify-content-between align-items-center gap-3 mb-3" style="line-height:1.1;">
                              <h5 class="mb-0" style="font-weight:600;">ЧК Digital Galaxy Ltd.</h5>
                              <span class="badge bg-light text-dark">Лицензия № AFSA-A-LA-2025-0001 (от 09.01.2025)</span>
                            </div>

                            <p class="mb-2">
                              ЧК Digital Galaxy Ltd. уполномочена в соответствии с лицензией № AFSA-A-LA-2025-0001 от 09.01.2025,
                              выданной Комитетом МФЦА по регулированию финансовых услуг (AFSA), осуществлять деятельность по:
                            </p>

                            <ol type="a" class="mb-2" style="margin-left:0; padding-left:0; list-style-position:inside;">
                              <li>Заключению сделок с цифровыми активами от своего имени</li>
                              <li>Заключению сделок с цифровыми активами от имени клиентов</li>
                              <li>Организация кастодиальных услуг</li>
                            </ol>

                            <p class="mb-2">
                              ЧК Digital Galaxy Ltd. является участником FinTech Lab (регуляторной песочницы)
                              и тестирует свои услуги и решения в рамках FinTech Lab МФЦА.
                            </p>

                            <p class="mb-0">
                              Статус лицензии Digital Galaxy Ltd. и её актуальность можно проверить
                              на официальном сайте
                              <a href="https://publicreg.myafsa.com/" target="_blank" rel="noopener noreferrer" class="link-light" style="text-decoration:underline;">регулятора</a>.
                            </p>
                          </div>
                        </div>
                      </div>
                    </b-col>

                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <!-- end of the footer -->

        <b-col lg="12" class="p-0 m-0 main-bottom-top mb-3"></b-col>

        <!-- begining of the bottom -->
        <b-col lg="12" class="p-0 m-0 px-5 pb-3">
          <b-row class="p-0 m-0 px-5">
            <b-col lg="6" class="m-0 p-0">
              <span class="copyright">© 2026 Payton by galaxy. Все права защищены</span>
            </b-col>
            <b-col lg="6" class="m-0 p-0 text-right pr-5"></b-col>
          </b-row>
        </b-col>
        <!-- end of the bottom -->


          </b-col>
        </b-row>
      </b-container>

      <!-- Policy modal component (only relevant for logged-in users) -->
      <PolicyModal
        :show="showPolicyModal"
        :loading="policyLoading"
        @accept="acceptPolicy"
        @logout="logOut"
      />

   </div>
</template>

<script>
import {mapActions,mapState} from 'vuex';
import axios from 'axios';
import { apiDomain,getHeader } from '@/config/config';
import { EventBus } from '@/EventBus';
import PolicyModal from '@/components/landing/PolicyModal';
import NotificationBell from '@/components/landing/NotificationBell';
export default {
  name: 'Landing',
  components: {
    PolicyModal,
    NotificationBell,
  },
  data(){
    return{
      classStatus:"",
      limitInvestment:0,
      // Остаток лимита за календарный месяц: приходит из /exchange/limit
      // (limit - used, где used суммирует все BUY-ордера с 1-го числа).
      // Отображается вместо полного limit'а — сразу видно, сколько
      // клиент может потратить сегодня, а не абстрактный «потолок».
      limitRemaining:0,
      // your existing data...
      currentLang: 'ru',
      languages: [
        { code: 'ru', label: 'Русский', flag: '🇷🇺' },
        { code: 'kk', label: 'Қазақ',   flag: '🇰🇿' },
        { code: 'en', label: 'ENG', flag: '🇬🇧' }
      ],
      kycResult:{
          status:"pending",
          classification:"uknown"
      },
      docs:[],
      loadedUserData:{},
      showPolicyModal: false,
      policyLoading: false,
    }

  },
  methods: {
    status() {
      return this.loadedUserData.onboardingStatus || 'NOTIDENTIFIED'
    },
    classificationStatus() {
      // Map the new client_category enum from the backend onto the legacy
      // UI status strings so the rest of the template (which still keys
      // off classStatus/classStatusLabel) keeps working unchanged.
      this.limitInvestment = this.loadedUserData.limitInvestment
      const cat = this.loadedUserData.clientCategory
      if (cat === 'PROFESSIONAL') {
        this.classStatus = 'PROFESSIONAL'
      } else if (cat === 'RETAIL_Q') {
        this.classStatus = 'QUALIFIED'
      } else if (cat === 'RETAIL_NQ') {
        this.classStatus = 'NONQUALIFIED'
      } else {
        this.classStatus = 'NOTIDENTIFIED'
      }
    },
    fetchLimit() {
      // Свежий remaining месячного лимита. Отделена от fetchUserDetails
      // потому что used меняется чаще (после каждого ордера), а базовые
      // юзер-данные — только при апгрейде категории.
      axios
        .get(`${apiDomain}/exchange/limit`, { headers: getHeader() })
        .then((res) => {
          this.limitRemaining = Number(res.data && res.data.remaining) || 0;
          // Общий лимит берём из того же свежего ответа. Иначе после
          // апгрейда категории limitInvestment (из userdetails) отстаёт:
          // userdetails успевает прочитаться до применения промоушена,
          // а /exchange/limit — уже после. Держим оба в одном источнике.
          if (res.data && res.data.limit != null) {
            this.limitInvestment = Number(res.data.limit) || 0;
          }
        })
        .catch(() => { /* fallback: показываем полный limit */ });
    },
    fetchUserDetails() {
      if (!this.loginedUser || !this.loginedUser.id) {
        return;
      }
      axios
        .get(
          `${apiDomain}/exchange/userdetails/${this.loginedUser.id}`,
          { headers: getHeader() }
        )
        .then(res => {
          this.loadedUserData = res.data || {};
          this.classificationStatus();
          this.fetchLimit();
          if (this.hasRole('CLIENT') && this.loadedUserData && this.loadedUserData.isPolicyConfirmed === 0) {
            this.showPolicyModal = true;
          }
          this.maybeShowSurveyReminder();
          this.maybeShowBasicTestReminder();
          this.maybeShowQualifiedSofReminder();
        })
        .catch(err => console.error(err))
    },
    changeRouteTop(name){

      this.$router.push({ name }).then(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      });
    },
    setLanguage(code) {
      this.currentLang = code;

      if (this.$i18n) {
        this.$i18n.locale = code;
      }
    },
    changeRoute(route){
      if (route === 'login') {
        this.$router.push("/login")
      }
      if (route === 'wallet') {
        this.$router.push('/userwallet')
      }
      if (route === 'settings') {
        this.$router.push('/identification/SHOW')
      }
      if (route === 'profile') {
        this.$router.push('/myprofile')
      }
      else if(route ==='landing'){
        this.$router.push('/landing')
      }
      else if (route === 'reg') {
        this.$router.push('/reg/person')
      }
      else if (route === 'bankinfo') {
        this.$router.push('/bankinfo')
      }
      else if (route === 'digitalwallet') {
        this.$router.push('/digitalwallet')
      }
      else if (route === 'transactions') {
        this.$router.push('/usertransactions')
      }
      else if (route === 'createOrder') {
        // If we already know the user is verified, jump straight to the
        // trade form — going through /identification/:type just to be
        // redirected back from Identification.vue's mounted() flashes
        // the onboarding screen for half a second. Fall back to the
        // gateway when userdetails hasn't loaded yet or category is
        // still NONE.
        const cat = this.loadedUserData && this.loadedUserData.clientCategory
        if (cat && cat !== 'NONE') {
          this.$router.push('/buy/BUY')
        } else {
          this.$router.push('/identification/BUY')
        }
      }
      else if (route === 'broker' || route==='orders') {
        this.$router.push('/orders')
      }
      else if (route === 'upgradeplan') {
        this.$router.push('/upgradeplan')
      }
    },
    logOut : function(){
      // ensure policy modal is closed as soon as user logs out
      this.showPolicyModal = false;
      window.localStorage.removeItem("authUser");
      window.localStorage.clear();
      this.logoutSystem();
      this.changeRoute('landing');
    },
    ...mapActions([
        'logoutSystem',
    ]),
    hasRole(roleName){

      if(this.loginedUser && this.loginedUser!=null && this.loginedUser.userRoles  && this.loginedUser.userRoles!=null){

          let roleNames = this.loginedUser.userRoles;
          if(roleNames.length>0){
            for(let r=0;r<roleNames.length;r++){

              if(roleNames[r].name===roleName){
                return true;
              }
            }
          }
          else{
            return false;
          }

      }

      return false;
    },
    docList(){
      axios.post(apiDomain+'/exchange/doc/useful',{},{headers:getHeader()})
      .then((response)=>{
          this.docs = response.data;

      })
      .catch((error)=>{
          console.log(error);
      });
    },
    guardClientNav(route) {
      // Требуем хотя бы базовую классификацию (NONQUALIFIED и выше)
      if (!this.canAccessClientMenus) {
        if (this.$bvToast) {
          this.$bvToast.toast(
            'Доступ к этому разделу возможен после прохождения идентификации и получения статуса клиента не ниже "Non-qualified".',
            {
              title: 'Требуется идентификация',
              variant: 'warning',
              autoHideDelay: 6000,
              toaster: 'b-toaster-top-center',
              solid: true,
            }
          );
        }
        return;
      }
      this.changeRoute(route);
    },
    acceptPolicy(payload) {
      if (this.policyLoading) {
        return;
      }
      this.policyLoading = true;
      // PolicyModal emits the three independent consents — Terms / Privacy /
      // Risk Warning. Send them through to the backend so each consent is
      // recorded with its own timestamp.
      const body = {
        terms:   !!(payload && payload.terms),
        privacy: !!(payload && payload.privacy),
        risk:    !!(payload && payload.risk),
      };
      axios
        .post(`${apiDomain}/payton/accept`, body, { headers: getHeader() })
        .then(() => {
          this.policyLoading = false;
          if (this.loadedUserData) {
            this.loadedUserData.isPolicyConfirmed = 1;
          }
          this.showPolicyModal = false;
          if (this.$bvToast) {
            this.$bvToast.toast('Спасибо! Политика конфиденциальности принята.', {
              variant: 'success',
              title: 'Принято',
              autoHideDelay: 4000,
              toaster: 'b-toaster-top-center',
              solid: true,
            });
          }
        })
        .catch((err) => {
          console.error('Ошибка при принятии политики:', err);
          this.policyLoading = false;
          if (this.$bvToast) {
            this.$bvToast.toast('Не удалось сохранить согласие. Попробуйте еще раз.', {
              variant: 'danger',
              title: 'Ошибка',
              autoHideDelay: 5000,
              toaster: 'b-toaster-top-center',
              solid: true,
            });
          }
        });
    },
    handleKycStatus(payload) {
      this.kycResult = payload;
    },
    showBackupLoginToast() {
      // Set by RLogin.vue when /login/verify-2fa returned used_backup_code.
      // We pop a toast once, then drop the flag so a page reload won't
      // replay it.
      const raw = window.sessionStorage.getItem('tfaBackupLogin');
      if (!raw) return;
      window.sessionStorage.removeItem('tfaBackupLogin');
      if (!this.$bvToast) return;
      let data = {};
      try { data = JSON.parse(raw) || {}; } catch (e) { /* ignore */ }
      const left = data.backupCodesLeft != null ? data.backupCodesLeft : '?';
      this.$bvToast.toast(
        `Вы вошли с помощью резервного кода. Осталось кодов: ${left}. ` +
        'Перенастройте 2FA на новом устройстве в «Мой профиль → Управлять».',
        {
          variant: 'warning',
          title: 'Вход по резервному коду',
          autoHideDelay: 12000,
          toaster: 'b-toaster-top-center',
          solid: true,
        }
      );
    },
    maybeShowSurveyReminder() {
      // Onboarding is approved but the mandatory survey hasn't been
      // filled — nudge the user with a persistent toast (no auto-hide)
      // that takes them straight to /identification/SHOW where the form
      // lives. Without this, closing the identification tab strands the
      // user with no way back to the questionnaire.
      if (!this.$bvToast) return;
      const d = this.loadedUserData || {};
      if (d.onboardingStatus !== 'APPROVED') return;
      const filled = d.isSurveyShown === 1 || d.isSurveyShown === true;
      if (filled) {
        // If the user just filled it, hide any stale reminder.
        this.$bvToast.hide('survey-reminder-toast');
        return;
      }
      // Use a fixed toast id so re-fetches (and HMR refreshes) reuse the
      // same toast instead of stacking copies. The survey is mandatory,
      // so we don't gate this on sessionStorage — if the user dismissed
      // it, the next fetchUserDetails round trip will re-pop it.
      const h = this.$createElement;
      const router = this.$router;
      const body = h('div', [
        h('div', 'Чтобы продолжить пользоваться платформой, заполните короткую анкету.'),
        h('div', { class: 'mt-2' }, [
          h('a', {
            attrs: { href: 'javascript:void(0)' },
            class: 'text-warning font-weight-bold',
            on: {
              click: (e) => {
                e.preventDefault();
                this.$bvToast.hide('survey-reminder-toast');
                router.push('/identification/SHOW').catch(() => {});
              },
            },
          }, 'Заполнить анкету →'),
        ]),
      ]);
      this.$bvToast.toast([body], {
        id: 'survey-reminder-toast',
        title: 'Незаполненная анкета',
        variant: 'warning',
        toaster: 'b-toaster-top-center',
        noAutoHide: true,
        solid: true,
      });
    },
    maybeShowBasicTestReminder() {
      // Survey is done but the BASIC risk-awareness test isn't — the
      // user is stuck at client_category='NONE' (the test promotes them
      // to RETAIL_NQ). Nudge them to /identification/SHOW where the
      // BASIC test modal lives. Skipped if the survey itself is still
      // missing (maybeShowSurveyReminder owns that case) so the user
      // sees one toast at a time, not two stacked.
      if (!this.$bvToast) return;
      const d = this.loadedUserData || {};
      if (d.onboardingStatus !== 'APPROVED') return;
      const surveyFilled = d.isSurveyShown === 1 || d.isSurveyShown === true;
      if (!surveyFilled) return;
      const cat = d.clientCategory;
      const basicPassed = cat && cat !== 'NONE';
      if (basicPassed) {
        this.$bvToast.hide('basic-test-reminder-toast');
        return;
      }
      const h = this.$createElement;
      const router = this.$router;
      const body = h('div', [
        h('div', 'Остался последний шаг — короткий тест на понимание рисков.'),
        h('div', { class: 'mt-2' }, [
          h('a', {
            attrs: { href: 'javascript:void(0)' },
            class: 'text-warning font-weight-bold',
            on: {
              click: (e) => {
                e.preventDefault();
                this.$bvToast.hide('basic-test-reminder-toast');
                router.push('/identification/SHOW').catch(() => {});
              },
            },
          }, 'Пройти тест →'),
        ]),
      ]);
      this.$bvToast.toast([body], {
        id: 'basic-test-reminder-toast',
        title: 'Пройдите тест на риски',
        variant: 'warning',
        toaster: 'b-toaster-top-center',
        noAutoHide: true,
        solid: true,
      });
    },
    maybeShowQualifiedSofReminder() {
      // After the user passes the qualified test we still need them to
      // upload Source-of-Funds documents before MLRO can promote them to
      // RETAIL_Q. The dedicated screen lives at /qualified-client, but
      // there's no obvious nav entry that gets them there — so we nudge
      // them with a toast once per session.
      if (!this.$bvToast) return;
      const d = this.loadedUserData || {};
      const passed = d.isPassedQualified === 1 || d.isPassedQualified === true;
      const cat = d.clientCategory;
      const sofPending = passed && cat !== 'RETAIL_Q' && cat !== 'PROFESSIONAL';
      if (!sofPending) return;
      // Suppress the nudge inside the Professional wizard — the user is
      // following a different path and shouldn't be pushed back to
      // /qualified just because they passed the same shared test.
      const routeName = this.$route && this.$route.name;
      const routePath = this.$route && this.$route.path;
      if (routeName === 'ProfessionalFlow' || routePath === '/professional') return;
      // If the user has any signal of being on the Professional track —
      // they took the Professional survey, have a pending Professional
      // application, or have any Professional-family documents on file
      // — don't push them toward Qualified SoF, that's a different path.
      if (d.isPassedProfessional === 1 || d.isPassedProfessional === true) return;
      if (d.hasProfessionalDocs === true) return;
      if (window.sessionStorage.getItem('qualifiedSofReminderShown')) return;
      window.sessionStorage.setItem('qualifiedSofReminderShown', '1');

      // Render the body as a vnode so we can attach a click-handler that
      // closes the toast and navigates via vue-router. Plain href= breaks
      // because b-toast intercepts clicks and may dismiss the toast
      // before the browser follows the link.
      const h = this.$createElement;
      const router = this.$router;
      const body = h('div', [
        h('div',
          'Вы успешно прошли квалификационный тест. Чтобы получить статус квалифицированного клиента — загрузите документы, подтверждающие источник средств.'
        ),
        h('div', { class: 'mt-2' }, [
          h('a',
            {
              attrs: { href: 'javascript:void(0)' },
              class: 'text-warning font-weight-bold',
              on: {
                click: (e) => {
                  e.preventDefault();
                  router.push('/qualified').catch(() => {});
                },
              },
            },
            'Загрузить документы →'
          ),
        ]),
      ]);
      this.$bvToast.toast([body], {
        title: 'Завершите оформление статуса',
        variant: 'warning',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 14000,
        solid: true,
      });
    },
  },
  computed:{
    ...mapState([
        'loginedUser'
    ]),
    // Full name if we know it, otherwise display_name / username — falls
    // back to a generic word so the dropdown never shows undefined.
    displayUserName() {
      const u = this.loginedUser || {}
      const full = [u.firstName, u.lastName].filter(Boolean).join(' ').trim()
      return full || u.displayName || u.userName || 'Пользователь'
    },
    userEmail() {
      const u = this.loginedUser || {}
      const v = u.email || u.userName || ''
      // Only treat it as an email if it looks like one — for some
      // legacy accounts userName is a plain login (e.g. 'admin').
      return v.indexOf('@') >= 0 ? v : ''
    },
    currentLangLabel() {
      const found = this.languages.find(l => l.code === this.currentLang);
      return found ? `${found.flag} ${found.label}` : this.currentLang;
    },
    currentLangFlag() {
      const found = this.languages.find(l => l.code === this.currentLang);
      return found ? found.flag : '🌐';
    },
    classStatusLabel() {
      const map = {
        NOTIDENTIFIED: 'Не определён',
        NONQUALIFIED:  'Розничный клиент (неквалифицированный)',
        QUALIFIED:     'Розничный клиент (квалифицированный)',
        PROFESSIONAL:  'Профессиональный клиент',
      };
      return map[this.classStatus] || this.classStatus;
    },
    // Same content as classStatusLabel split into a primary line and an
    // optional qualifier (the bit in parentheses), so the header badge
    // can render it on two lines instead of a long single chip.
    classStatusLines() {
      const map = {
        NOTIDENTIFIED: { main: 'Не определён',         qualifier: '' },
        NONQUALIFIED:  { main: 'Розничный клиент',     qualifier: 'неквалифицированный' },
        QUALIFIED:     { main: 'Розничный клиент',     qualifier: 'квалифицированный' },
        PROFESSIONAL:  { main: 'Профессиональный клиент', qualifier: '' },
      };
      return map[this.classStatus] || { main: this.classStatus, qualifier: '' };
    },
    onboardingStatusLabel() {
      // Keep the wording in sync with MyProfile's identificationStatus:
      // both surfaces describe the same lms_core_user.onboarding_status
      // field, so swapping between them shouldn't leave the user
      // wondering whether "Подтверждён" and "Пройдена" mean the same
      // thing. Source of truth lives here and in MyProfile.vue —
      // change them together.
      const map = {
        NOTIDENTIFIED: 'Не пройдена',
        PENDING:       'На проверке',
        APPROVED:      'Пройдена',
        REJECTED:      'Отклонена',
      };
      const st = this.loadedUserData.onboardingStatus || 'NOTIDENTIFIED';
      return map[st] || st;
    },
    canAccessClientMenus() {
      // базовое требование: классификация клиента не "NOTIDENTIFIED"
      return this.classStatus && this.classStatus !== 'NOTIDENTIFIED';
    },
    // Аккаунт заморожен: клиент входит в ЛК, но сервисы недоступны.
    isAccountFrozen() {
      const v = this.loadedUserData && this.loadedUserData.accountFrozen;
      return v === 1 || v === '1' || v === true;
    }
  },
  created(){
      this.fetchUserDetails();
      EventBus.$on('kyc-status', this.handleKycStatus);
      EventBus.$on('refresh-user-details', this.fetchUserDetails);
      // Отдельная шина для лимита — BuyCrypto после успешного ордера
      // эмитит её, шапка тут же перечитывает remaining.
      EventBus.$on('refresh-limit', this.fetchLimit);
  },
  watch: {
    // Освежаем лимит в шапке при каждой навигации клиента — цифры
    // могли устареть после апгрейда категории или создания ордера, а
    // без перезагрузки страницы хедер их не перечитывал. Запрос лёгкий
    // (один SELECT), для гостя тихо падает в catch.
    $route() {
      if (this.hasRole && this.hasRole('CLIENT')) this.fetchLimit();
    },
  },
  mounted() {
      this.showBackupLoginToast();
      // Bootstrap notifications: only meaningful for logged-in CLIENT
      // users. The store will no-op if there's no auth header.
      if (this.hasRole && this.hasRole('CLIENT')) {
        // Базовая планка — новейший известный нам id уведомления
        // (переживает перезагрузку через vuex-persistedstate). Тостим
        // только элементы новее неё, чтобы F5 не всплывал старые.
        const knownList = this.$store.state.notifications || []
        let lastToastedId = knownList.length ? knownList[0].id : 0
        // The pollerId is persisted by vuex-persistedstate — after a
        // page reload it points at an interval id that no longer
        // exists, so the start-guard would silently no-op. Stop first
        // (a clear()-on-null is safe) to drop the stale id, then
        // start fresh.
        this.$store.dispatch('stopNotificationsPolling')
        this.$store.dispatch('startNotificationsPolling')
        // Тост вешаем на изменение самого СПИСКА (новейший id), а не на
        // счётчик непрочитанных: поллер обновляет счётчик раньше списка,
        // поэтому watcher по счётчику читал бы ещё старый список и
        // показывал предпоследнее уведомление. Список — newest-first
        // (id DESC), значит notifications[0] — самое свежее.
        this.$watch(
          () => {
            const list = this.$store.state.notifications || []
            return list.length ? list[0].id : 0
          },
          (newestId) => {
            if (newestId <= lastToastedId || !this.$bvToast) return
            lastToastedId = newestId
            const fresh = (this.$store.state.notifications || [])[0]
            if (fresh && !fresh.isRead) {
              this.$bvToast.toast(fresh.body || ' ', {
                title: fresh.title,
                variant: fresh.type === 'CLASSIFICATION_REJECTED' ? 'danger' : 'success',
                solid: true,
                toaster: 'b-toaster-top-right',
                autoHideDelay: 6000,
                // Приложение в hash-режиме: ссылка бэкенда «/order/…»
                // без «/#/» ведёт на полную перезагрузку → not found.
                // Префиксуем «/#», чтобы навигация шла через роутер.
                href: fresh.link ? ('/#' + fresh.link) : undefined,
              })
            }
          }
        )
      }
  },
  beforeDestroy() {
      EventBus.$off('kyc-status', this.handleKycStatus);
      EventBus.$off('refresh-user-details', this.fetchUserDetails);
      this.$store.dispatch('stopNotificationsPolling');
  },
}
</script>

<style>
  html {
    scroll-behavior: smooth;
  }

  /* Баннер заморозки аккаунта — постоянно виден в ЛК, пока аккаунт заморожен. */
  .frozen-banner {
    display: flex;
    align-items: flex-start;
    gap: 4px;
    margin: 16px 24px 0;
    padding: 14px 18px;
    border: 1px solid #FED7AA;
    border-radius: 12px;
    background: #FFF7ED;
    color: #B45309;
    font-size: 14px;
    line-height: 1.5;
  }

  /* Заголовки разделов в футере («Контакты», «Жалобы и претензии») —
     выделены как самостоятельные разделы. */
  .footer-section-title {
    text-align: left;
    font-weight: 700;
    font-size: 15px;
    line-height: 1.3;
    color: #FCFCFD;
  }
  .footer-section-title--gap {
    margin-top: 16px;
  }

  /* ===== BEAUTIFUL NAVBAR (no layout breaking) ===== */
  .custom-navbar{
    border-bottom: 1px solid rgba(255,255,255,0.10);
    background: rgba(0,0,0,0.78) !important;
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    position: sticky;
    top: 0;
    z-index: 1035;
  }

  .brand-wrap{
    display:flex;
    align-items:center;
    flex: 0 0 auto;
    min-width: 150px;
  }
  .brand-wrap svg{
    flex-shrink: 0;
    display:block;
  }

  .nav-right{
    gap: .35rem;
    padding-right: 1rem;
  }

  .nav-toggle{
    margin-right: 1rem;
    border-radius: 12px !important;
    border: 1px solid rgba(255,255,255,0.18) !important;
    padding: .25rem .6rem !important;
  }

  .nav-collapse-modern{
    padding-right: .75rem;
    align-items: flex-start;
  }
  .nav-left,
  .nav-kyc,
  .nav-right{
    align-items: flex-start;
  }
  .nav-kyc{
    margin-left: .5rem;
  }

  @media (max-width: 991px){
    .nav-collapse-modern{
      margin-top: .75rem;
      padding: .75rem;
      border-radius: 16px;
      background: rgba(255,255,255,0.04);
      border: 1px solid rgba(255,255,255,0.08);
    }
  }

  /* dropdown styling */
  .dropdown-high-z{
    z-index: 9999 !important;
  }
  .dropdown-modern{
    background: rgba(15, 15, 18, 0.98) !important;
    border: 1px solid rgba(255, 255, 255, 0.12) !important;
    border-radius: 16px !important;
    padding: 0.4rem !important;
    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.65) !important;
    min-width: 220px;
  }
  .dropdown-modern .dropdown-item{
    border-radius: 12px !important;
    padding: 0.6rem 0.75rem !important;
    color: #fcfcfd !important;
    font-weight: 600;
  }
  .dropdown-modern .dropdown-item:hover{
    background: rgba(255,255,255,0.08) !important;
  }

  .lang-toggle,
  .user-toggle {
    width: 40px !important;
    height: 40px !important;
    padding: 0 !important;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    border-radius: 999px !important;
    border: 1px solid rgba(255,255,255,0.20) !important;
    background: rgba(255,255,255,0.04) !important;
    font-size: 0.85rem;
  }
  .lang-toggle:hover,
  .user-toggle:hover {
    background: rgba(255,255,255,0.08) !important;
  }
  .lang-flag { font-size: 1.15rem; line-height: 1; }

  #lang-dropdown .dropdown-menu {
    min-width: 180px;
  }

  .btn-ghost{
    border: 1px solid rgba(255,255,255,0.22) !important;
    background: rgba(255,255,255,0.04) !important;
  }
  .btn-ghost:hover{
    background: rgba(255,255,255,0.08) !important;
    transform: translateY(-1px);
  }

  .btn-gold{
    box-shadow: 0 14px 30px rgba(239,185,20,0.18);
  }
  .btn-gold:hover{
    transform: translateY(-1px);
  }

  .btn-trade{
    box-shadow: 0 16px 38px rgba(40,167,69,0.18);
  }
  .btn-trade:hover{
    transform: translateY(-1px);
    box-shadow: 0 20px 48px rgba(40,167,69,0.24);
  }

  .btn-outline-soft{
    border-color: rgba(23,162,184,0.55) !important;
  }
  .btn-outline-soft:hover{
    background: rgba(23,162,184,0.12) !important;
    transform: translateY(-1px);
  }

  .kyc-card{
    border-radius: 14px;
    background: transparent;
    border: none;
  }
  /* Инфо-блоки (Идентификация/Классификация/Лимит) не кликабельны. */
  .kyc-card,
  .kyc-card .nav-link{
    cursor: default;
  }

  /* keep your original styles */
  .no-style {
      color: inherit;
      text-decoration: none;
  }
  .no-style:hover {
      color: inherit;
      text-decoration: none;
  }
  .no-style-input{
      appearance: none;
      background-color: transparent;
      border: none;
      outline: none;
      font-family: inherit;
      font-size: inherit;
      color: inherit;
      line-height: inherit;
      padding: 0;
      margin: 0;
  }
  .sep {
    border-right: 1px solid #23262F;
  }
  .main-menu{
    color: var(--Neutrals-4, #777E90);
    text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
  }
  .reg-btn{
    border-radius: 8px;
    background: var(--Primary-1, #EFB914);
  }
  .login-btn{
    border-radius: 8px;
    border: 2px solid var(--Neutrals-4, #777E90);
  }
  .login-btn-text{
    color: var(--Neutrals-8, #FCFCFD);
    text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
  }
  .navbar-nav .btn {
    font-size: 0.95rem;
  }
  .reg-label {
    font-size: 0.8rem;
    letter-spacing: .06em;
    text-align: left;
  }
  /* Единая «пилюля» для актуальной информации под всеми тремя полями —
     одинаковый размер, выравнивание по левому краю, нейтральный фон. */
  .kyc-value {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 4px;
    padding: 0;
    background: transparent;
    border: none;
    color: #E6E8EC;
    font-weight: 600;
    font-size: 0.9rem;
    line-height: 1.15;
    white-space: nowrap;
    text-align: left;
  }
  .kyc-dollar { color: var(--Primary-1, #EFB914); }
  /* Действия: колонкой, чтобы «Повысить лимит» и «Создать ордер»
     ложились друг над другом при нехватке места. */
  .kyc-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
</style>
